import { ENTER_KEY, SPACE_KEYCODE, ENTER_KEYCODE } from '../../../../../Utils/constant';
export const keyPressFunctions = {
  expand: [ENTER_KEY, ENTER_KEYCODE, SPACE_KEYCODE],
  collapse: [],
  selection: [ENTER_KEY, ENTER_KEYCODE, SPACE_KEYCODE]
};